import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';

function navFunction() {
	if($(".wp-block-thefuturblocks-post-navigation__post").length) {
		var fn;
		$(".wp-block-thefuturblocks-post-navigation__post--next").each(function() {
			var self = $(this),
				link = self.find('.wp-block-thefuturblocks-post-navigation__link'),
				sub = self.find('.wp-block-thefuturblocks-post-navigation__subtitle'),
			    title = self.find('.wp-block-thefuturblocks-post-navigation__title'),
			    tl = gsap.timeline({paused:true});

			if(link.length) {
				tl
				  .to(sub, {duration:0.5,yPercent:-100,skewY:-10,ease: "sine.in"})
				  .fromTo(title, {skewY:-10,yPercent:100}, {duration:0.5,yPercent:-100,skewY:0,ease:"sine.out"}, "<");

				self.on("mouseenter", () => {
					tl.play();
				}).on("mouseleave", () => {
					tl.reverse();
				})
			}
		})
		
		$(".wp-block-thefuturblocks-post-navigation__post--prev").each(function() {
			var self = $(this),
				link = self.find('.wp-block-thefuturblocks-post-navigation__link'),
				sub = self.find('.wp-block-thefuturblocks-post-navigation__subtitle'),
			    title = self.find('.wp-block-thefuturblocks-post-navigation__title'),
			    tl = gsap.timeline({paused:true});

			if(link.length) {
				tl
				  .to(sub, {duration:0.5,yPercent:-100,skewY:10,ease:"sine.in"})
				  .fromTo(title, {skewY:10,yPercent:100}, {duration:0.5,yPercent:-100,skewY:0,ease:"sine.out"}, "<");

				self.on("mouseenter", () => {
					tl.play();
				}).on("mouseleave", () => {
					tl.reverse();
				})
			}
		})

		fn = function buttonAnim() {
			var btn = $(".wp-block-thefuturblocks-post-navigation__button");
			if(btn.length) {
				var btnLink = btn.find('a'),
					btnSpanF = btnLink.find('span:nth-child(1)'),
					btnSpanS = btnLink.find('span:nth-child(2)'),
					btnSpanT = btnLink.find('span:nth-child(3)'),
					btnSpanFo = btnLink.find('span:nth-child(4)'),
				    tl = gsap.timeline({paused:true});
				tl.to(btnSpanF, {duration:0.3,x:11, rotate:180, ease:"none", force3D:false})
				.to(btnSpanS, {duration:0.3,y:11, rotate:180, ease:"none", force3D:false},"<")
				.to(btnSpanT, {duration:0.3,y:-11, rotate:180, ease:"none", force3D:false},"<")
				.to(btnSpanFo, {duration:0.3,x:-11, rotate:180, ease:"none", force3D:false},"<");

				btnLink.on("mouseenter", () => {
					tl.play()
				}).on("mouseleave", () => {
					tl.reverse();
				})
			}
		}
		fn()
	}
}
navFunction();